export const RESET_OTP = 'Otp/RESET_OTP';

export const SEND_OTP = 'Otp/SEND_OTP';
export const SEND_OTP_SET_DATA = 'Otp/SEND_OTP_SET_DATA';

export const RESEND_OTP = 'Otp/RESEND_OTP';
export const RESEND_OTP_SET_DATA = 'Otp/RESEND_OTP_SET_DATA';
